import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Headline, Paragraph, Subheader } from '@cambridgeassessment/cambridge-ui';
import { ReportType } from '@cambridgeassessment/lib-ee-commons';
import Loader from '../../../../components/Loader/Loader';
import thunks from '../../../../store/series/thunks';
import { RootState } from '../../../../store';
import ReportList from '../../../../components/ReportList/ReportList';

const TrainingReports: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const { businessUnit } = useSelector((state: RootState) => state.userData);
  const { trainingReports, isLoading, hasError } = useSelector((state: RootState) => state.series);

  useEffect(() => {
    if (businessUnit) dispatch(thunks.getSeriesReportsData(businessUnit.id, ReportType.TRAINING));
  }, [businessUnit, dispatch]);

  if (isLoading) return <Loader />;

  if (hasError) return <div>Failed to get Series training reports</div>;

  return (
    <div data-qa-id='page-priming-training-reports'>
      <Headline data-qa-id='training-reports-headline'>Training reports</Headline>
      <Paragraph data-qa-id='training-reports-paragraph'>You can explore and download reports from series</Paragraph>
      <Subheader data-qa-id='training-reports-subheader'>Available reports</Subheader>
      {trainingReports?.length && <ReportList data={trainingReports} dataQaId='training-reports-list' />}
    </div>
  );
};

export default TrainingReports;
